import React, { FC } from "react";
import classNames from "classnames";
import { Fade } from "react-awesome-reveal";
import { StaticImage } from "gatsby-plugin-image";
import { useTranslation } from "react-i18next";
import { DEFAULT_FADE_DURATION } from "@app/constants";

export const SideImage: FC = () => {
  const { t } = useTranslation("p_bank_apple-pay");

  return (
    <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
      <div
        className={classNames(
          "mt-20 flex flex-col rounded-lg border border-divider",
          "md:flex-row md:rounded-sm",
          "lg:mt-25",
          "xl:mt-40 xl:max-w-container xl:rounded-lg xl:border-0 xl:bg-dark",
          "xxl:gap-10",
        )}
      >
        <div
          className={classNames(
            "flex flex-col justify-end overflow-hidden rounded-t-lg bg-dark",
            "md:w-1/2 md:rounded-t-sm md:bg-transparent",
            "xl:pl-20",
          )}
        >
          <StaticImage
            src={"./apple_wallet.webp"}
            alt="Apple Wallet"
            className={classNames(
              "relative mx-auto w-1/2 translate-y-[15%]",
              "md:w-3/4",
              "xxl:w-[59%]",
            )}
          />
        </div>
        <div
          className={classNames(
            "px-9 py-5 text-regular text-base-400",
            "md:flex md:w-1/2 md:flex-col md:justify-center md:px-10 md:py-10",
            "xl:px-20 xl:py-20",
          )}
        >
          <h3
            className={classNames(
              "mb-2.5 text-medium text-primary-content",
              "lg:mb-5 lg:text-large",
              "xl:mb-8 xl:text-extra-large",
            )}
          >
            {t("how_to_title")}
          </h3>
          <p className={classNames("mb-10")}>{t("how_to_paragraph")}</p>
          <ol className="list-inside list-decimal">
            {(t("how_to_steps", { returnObjects: true }) as string[]).map(
              (item) => (
                <li key={item}>{item}</li>
              ),
            )}
          </ol>
        </div>
      </div>
    </Fade>
  );
};
